module.exports = __webpack_public_path__ + "static/img/logo-cn.d3f8739e.png";